import * as React from 'react';
import {render} from 'react-dom';
import Main from './compornents/main/main';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

const pages = [
  { path: "/:lang?", component: Main, lang: "ja" },
];

export default function App() {
  return (
    <Router>
      <Routes>
        {pages.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
      </Routes>
    </Router>
  );
}

export function renderToDom(container) {
  render(<App />, container);
}
